import React from 'react'
import './SectionTitle.css'

export default function SectionTitle({ title }) {
  // Render
  return (
    <div className="SectionTitle">
      <h4>{title}</h4>
    </div>
  )
}
